import React from 'react';
import styled from 'styled-components';
import ResponsiveView from '../../layout/ResponsiveView';

// 칩스 컨테이너 (모바일용)
const MobileChipsContainer = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  margin-top: 8px;
  
  /* 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

// 칩스 컨테이너 (데스크톱용)
const DesktopChipsContainer = styled.div`
  display: flex;
  gap: 12px;
  padding: 0 16px 12px 16px;
  margin-top: 16px;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

// 칩 버튼
const ChipButton = styled.button<{ $isActive: boolean }>`
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 15px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  
  ${({ $isActive }) => 
    $isActive 
      ? `
        background: #262626;
        color: #ffffff;
        border: 1px solid #262626;
      `
      : `
        background: #ffffff;
        color: #666666;
        border: 1px solid #cccccc;
        
        &:hover {
          border-color: #999999;
        }
      `
  }
`;

// 칩 아이템 인터페이스
export interface ChipItem {
  key: string;
  label: string;
}

// Props 인터페이스
interface FilterChipsProps {
  chips: ChipItem[];
  selectedChips: string[]; // 다중 선택을 위한 배열
  onChipClick: (chipKey: string) => void;
  allowMultiSelect?: boolean; // 다중 선택 허용 여부
}

const FilterChips: React.FC<FilterChipsProps> = ({
  chips,
  selectedChips,
  onChipClick,
  allowMultiSelect = false
}) => {
  const renderChips = () => (
    <>
      {chips.map((chip) => {
        const isActive = allowMultiSelect 
          ? selectedChips.includes(chip.key)
          : selectedChips.length === 1 && selectedChips[0] === chip.key;
          
        return (
          <ChipButton
            key={chip.key}
            $isActive={isActive}
            onClick={() => onChipClick(chip.key)}
          >
            {chip.label}
          </ChipButton>
        );
      })}
    </>
  );

  return (
    <ResponsiveView
      mobileView={
        <MobileChipsContainer>
          {renderChips()}
        </MobileChipsContainer>
      }
      desktopView={
        <DesktopChipsContainer>
          {renderChips()}
        </DesktopChipsContainer>
      }
    />
  );
};

export default FilterChips;
